import { AddToBagStateEnum } from '@inter-ikea-kompis/component-add-to-bag';
import { ConfigurationSummaryConfirmationCardLogInAndSaveStateEnum, ConfigurationSummaryConfirmationCardStateEnum, ConfirmationSummaryKioskMainCTAButtonStateEnum, ConfirmationSummaryShareDesignStateEnum } from '@inter-ikea-kompis/component-configuration-summary';
import { SaveDesignToProfileStateEnum } from '@inter-ikea-kompis/component-save-design-to-profile';
import { SendByEmailStateEnum } from '@inter-ikea-kompis/component-send-by-email';
import { ShareDesignCardStateEnum } from '@inter-ikea-kompis/component-share-design-card';
import { ZipInCardStateEnum, ZipInDefaultState } from '@inter-ikea-kompis/component-zip-in';
export default {
    translations: null,
    settings: null,
    shoppingProducts: null,
    storeAvailabilities: null,
    stores: null,
    financingOption: null,
    includedProducts: null,
    failedShoppingItems: null,
    addToCartState: AddToBagStateEnum.default,
    addToListState: AddToBagStateEnum.default,
    shareDesignState: ConfirmationSummaryShareDesignStateEnum.default,
    shareDesignCard: {
        state: ShareDesignCardStateEnum.default,
        autocomplete: true,
        showGetLink: true,
        showSendByEmail: true,
        sendByEmailState: SendByEmailStateEnum.default,
        showCopyDesignCodeButton: true,
        showCopyLink: true
    },
    kioskMainCTAButtonState: ConfirmationSummaryKioskMainCTAButtonStateEnum.default,
    buyInStore: {
        buyInStoreLink: null
    },
    saveDesignToProfile: {
        saveDesignState: SaveDesignToProfileStateEnum.default,
        loggedIn: false
    },
    logInAndSaveState: ConfigurationSummaryConfirmationCardLogInAndSaveStateEnum.default,
    confirmationCardType: null,
    confirmationCardState: ConfigurationSummaryConfirmationCardStateEnum.default,
    addUnavailableProductsToList: false,
    collectedProducts: null,
    visibleModal: null,
    storeId: null,
    homeDelivery: {
        state: ZipInCardStateEnum.default,
        zipAvailabilities: null
    },
    vpcCode: null,
    designSaved: false,
    componentLoadedEventSent: false,
    productListRemovable: [],
    serviceOptionsWithSettings: null,
    saveDesignOnReload: false,
    zipCode: null,
    assemblyServices: {
        state: ZipInCardStateEnum.default,
        assemblyServicesData: null
    },
    zipInState: ZipInDefaultState
};
//# sourceMappingURL=SummaryPageControllerDefaultState.js.map